import React from 'react'
import { i18nTranslate } from 'src/utils'
import { BsFillExclamationCircleFill } from 'react-icons/bs'

class SubscriptionErrorNotification extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    // const {case} = this.props
    let errorMessage

    switch (this.props.case) {
      case 'CCExpired':
        errorMessage = (
          <>
            {i18nTranslate(
              'payment.ccExpireRecMsg',
              'Our records indicate your'
            )}{' '}
            <b>
              {i18nTranslate(
                'payment.ccExpiredMsg',
                'subscription payment method is expiring soon or has expired.'
              )}
            </b>
            &nbsp;
            {i18nTranslate(
              'payment.ccExpireActionMsg',
              'To ensure you continue receiving your subscription shipments, please add a new subscription payment method. This can be done by clicking the edit icon for Payment Method on your subscription dashboard.'
            )}
          </>
        )
        break

      case 'ProcessError':
        errorMessage = (
          <>
            {i18nTranslate(
              'subscription.processError',
              'There was an issue processing your order on'
            )}{' '}
            <b>{this.props.date}</b>.{' '}
            {i18nTranslate(
              'subscription.processReview',
              'Please review your subscription details and use the'
            )}{' '}
            <b>{i18nTranslate('orderNow.heading', 'Order Now')}</b>{' '}
            {i18nTranslate(
              'subscription.processSubmit',
              'button to submit your order.'
            )}
          </>
        )
        break

      case 'OneTimeError':
        errorMessage = (
          <>
            {i18nTranslate(
              'subscription.oneTimeErrorNotification',
              'One-time items won’t ship without a recurring item.'
            )}
          </>
        )
        break

      default:
        errorMessage = <></>
        break
    }
    return (
      <div className="subscription-error-message p-3 mb-2">
        <BsFillExclamationCircleFill size="1rem" className={`tick-icon red`} />
        <p className="mb-0 ml-4">{errorMessage}</p>
      </div>
    )
  }
}

export default SubscriptionErrorNotification
export { SubscriptionErrorNotification }
